import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const ConfirmArea = styled.div(() =>
  mq({
    backgroundColor: '#fff',
    padding: `${defaultTheme.spacing.xl} ${defaultTheme.spacing.l}`,
    '& > button': {
      marginTop: '20px',
    },
  }),
);

export const ConfirmText = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    lineHeight: defaultTheme.font.height.l,
    textAlign: 'center',
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    paddingBottom: defaultTheme.font.size.l,
    p: {
      fontSize: defaultTheme.font.size.l,
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.l,
    },
  }),
);

export const Detail = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.s,
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    padding: `${defaultTheme.spacing.l} 0`,
  }),
);

export const Title = styled.span(() =>
  mq({
    color: defaultTheme.color.grayScale.dark,
    lineHeight: defaultTheme.font.height.l,
  }),
);

export const AutoChargeSelectWrapper = styled.div(() =>
  mq({
    paddingTop: defaultTheme.spacing.xxl,
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    marginTop: defaultTheme.spacing.xxl,
    button: {
      marginBottom: defaultTheme.spacing.xl,
    },
  }),
);

export const ChocomNotice = styled.p(() =>
  mq({
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.xs,
    marginTop: '40px',
  }),
);

export const Note = styled.p(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    color: defaultTheme.text.gray,
    fontSize: defaultTheme.font.size.xs,
    marginTop: defaultTheme.spacing.xxl,
    '&::before': {
      content: '"※"',
    },
  }),
);

export const BeforeBetConfirmText = styled.div(() =>
  mq({
    margin: `${defaultTheme.spacing.l} 0 ${defaultTheme.spacing.xxl}`,
    '& > p': {
      color: defaultTheme.text.gray,
      fontSize: defaultTheme.font.size.xs,
    },
  }),
);

export const LinkText = styled.span(() =>
  mq({
    display: 'block',
    '& > a': {
      textDecorationLine: 'underline',
      ...hoverOpacity,
    },
  }),
);

export const PaymentMethodLink = styled.a(() =>
  mq({
    display: 'block',
    textDecorationLine: 'underline',
    marginTop: defaultTheme.spacing.s,
    ...hoverOpacity,
  }),
);
